/* eslint-disable @typescript-eslint/naming-convention */
import { ClassRequirementDto } from './ClassRequirementDto';

export interface ClassCodeDto {
  ClassCodeID: string;
  TradeClassID: string | null;
  CompanyID: string;
  Code: string;
  bActive: boolean;
  VPCompanyID: number;
  DisplayName: string;
  ClassRequirements: ClassRequirementDto[];
  TradeGroupID: string | null;
  TradeClassRequirements: ClassRequirementDto[];
  /** Client side only */
  isClassRequirementsLoaded: boolean;
  /** Client side only */
  isDirty: boolean;
  /** Client side only */
  isInvalid: boolean;
  /** Client side only */
  isSelected: boolean;
}
